module.exports = __webpack_public_path__ + "static/media/instagram.db759f2a.svg";